<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col s12">
          <h2>{{ pageName }}</h2>
        </div>
      </div>

      <div :class="`card-panel ${css.cardLightColored}`">
        <div class="row">
          <div class="col s12 m12 l4">
            <p>
              <object
                class="img-left img-icon-medium"
                :data="require('@/assets/images/layout/quaese.svg')"
                type="image/svg+xml"
              >
                <img
                  class="img-left"
                  src="@/assets/images/layout/quaese__55x80.png"
                  alt="Quaese"
                />
              </object>
              Mein Name ist <strong>Markus Höllein</strong> oder einfach
              <strong>Quaese</strong>. Ich bin Frontend- und Webentwickler.
              Diese Website möchte ich als Plattform nutzen, um meine Person und
              meine Fertigkeiten näher vorzustellen.
            </p>
            <p>
              Derzeit arbeite ich als JavaScript-Developer und entwerfe und
              realisiere Lösungen für ein weltweites Online-Shopsystem. Neben
              der Tätigkeit als Entwickler bin ich für die Ausbildung der
              Auszubildenden verantwortlich.
            </p>
            <!-- <p class="z-depth-1"></p> -->
          </div>
          <div class="col s12 m6 l4">
            <p>
              Ob <strong>CSS-basiertes</strong> oder
              <strong>responsives Design</strong>, ob
              <strong>Usability</strong> und <strong>Barrierefreiheit</strong>,
              ob <strong>JavaScript</strong> und <strong>Ajax</strong> - alles
              Techniken und Technologien, die mich seit gute eineinhalb
              Jahrzehnten begleiten. Einige fanden erst während dieses Zeitraums
              Einzug in die Webentwicklung und so bot sich mir die Gelegenheit,
              sie "von der Pike auf" zu erlernen.
            </p>
          </div>
          <div class="col s12 m6 l4">
            <p>
              Neben den Basisfertigkeiten eines Frontendentwicklers konnte ich
              mir sehr gute Kenntnisse und praktisches Wissen in
              <strong>nativem JavaScript</strong>, diversen
              <strong>JavaScript-Frameworks</strong>, <strong>CSS3</strong> mit
              diversen Frameworks, <strong>HTML5</strong>, sowie
              <strong>Taskrunnern</strong> aneignen. Basiserfahrungen mit
              <strong>Node.js</strong> besitze ich ebenfalls.
            </p>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .card-panel -->

      <div class="row padding-top-medium">
        <h3 class="col s12">Kompetenzen</h3>
      </div>
      <!-- .row -->

      <div class="row">
        <div class="col s12 m6 l6">
          <div
            :class="
              `card card-min-height-medium ${css.cardLight} card-border-top card-border-blue`
            "
          >
            <div class="card-content">
              <span class="card-title col-header">
                <i class="small material-icons icons-blue">code</i>
                <span class="card-title-text">JavaScript/Frameworks</span>
              </span>
              <p>
                Frameworks, die ich bereits in Projekten eingesetzt habe oder
                mit denen ich beruflich gearbeitet habe.
              </p>
              <ul class="card-list">
                <!-- <li>natives JavaScript</li> -->
                <li>
                  <a href="https://jquery.com/">jQuery</a> /
                  <a href="http://jqueryui.com">jQueryUI</a>
                </li>
                <li><a href="https://vuejs.org/">Vue.js</a></li>
                <li><a href="https://svelte.dev/">Svelte</a></li>
                <li><a href="https://reactjs.org/">React</a></li>
                <li>
                  <a href="https://angular.io/">Angular</a> /
                  <a href="https://angularjs.org/">AngularJS</a>
                </li>
                <li><a href="https://dojotoolkit.org/">Dojo</a>,</li>
                <li><a href="http://prototypejs.org/">Prototype</a></li>
                <li><a href="https://Node.js.org/en/">Node.js</a></li>
              </ul>

              <p>
                Weiterhin habe ich schon <strong>2008</strong> eine
                deutschsprachige Online-Dokumentation für das HTML5-Element
                <strong>Canvas</strong> verfasst.
              </p>
              <ul class="card-list">
                <li><a href="http://canvas.quaese.de">canvas.quaese.de</a></li>
              </ul>
            </div>
            <!-- <div class="card-action">
                            <a href="#">This is a link</a>
                            <a href="#">This is a link</a>
                        </div> -->
          </div>
          <!-- .card -->
          <!-- <p class="z-depth-1"></p> -->
        </div>

        <div class="col s12 m6 l6">
          <div
            :class="
              `card card-min-height-medium ${css.cardLight} card-border-top card-border-red`
            "
          >
            <div class="card-content">
              <span class="card-title col-header">
                <i class="small material-icons icons-red">extension</i>
                <span class="card-title-text">CSS3/Frameworks</span>
              </span>
              <p>
                Meine Kompetenzen im Umfeld von CSS erstrecken sich über
                folgende Bereiche:
              </p>
              <ul class="card-list">
                <li>CSS3</li>
                <li>moderne Design-Praktiken (flexbox, grid)</li>
                <li><a href="http://getbootstrap.com/">Bootstrap</a></li>
                <li><a href="http://materializecss.com/">Materialize</a></li>
              </ul>

              <p>
                <strong>Stylesheet-Sprache</strong> zur intelligenten Steuerung
                und zum Vermeiden von Code-Wiederholungen
              </p>
              <ul class="card-list">
                <li><a href="http://lesscss.org/">{less}</a></li>
              </ul>
            </div>
          </div>
          <!-- .card -->
        </div>
      </div>
      <!-- .row -->

      <div class="row">
        <div class="col s12 m6 l6">
          <div
            :class="
              `card card-min-height-medium ${css.cardLight} card-border-top card-border-green long-content`
            "
          >
            <div class="card-content">
              <span class="card-title col-header">
                <i class="small material-icons icons-green">build</i>
                <span class="card-title-text">Automation</span>
              </span>
              <p>
                In der modernen Webentwicklung kommen immer häufiger
                Automationen und standardisierte Verfahren zum Einsatz, um
                Installationen oder wiederkehrende Aufgaben zu vereinfachen.
              </p>

              <h6>Taskrunner</h6>
              <ul class="card-list">
                <li><a href="http://gruntjs.com/">Grunt</a></li>
                <li><a href="http://gulpjs.com/">Gulp</a></li>
              </ul>

              <h6>Package Manager</h6>
              <ul class="card-list">
                <li>
                  <a href="https://www.npmjs.com/"
                    >NPM (Node Package Manager)</a
                  >
                </li>
                <li><a href="http://bower.io/">Bower</a></li>
              </ul>
            </div>
          </div>
          <!-- .card -->
        </div>

        <div class="col s12 m6 l6">
          <div
            :class="
              `card card-min-height-medium ${css.cardLight} card-border-top card-border-yellow long-content`
            "
          >
            <div class="card-content">
              <span class="card-title col-header">
                <i class="small material-icons icons-yellow">whatshot</i>
                <span class="card-title-text">Sonstiges</span>
              </span>
              <!-- <p>
                                In den folgenden Graphik-, Modelling- und Vektorprogrammen besitze ich solide Kenntnisse.
                            </p> -->

              <h6>Graphik</h6>
              <ul class="card-list">
                <li>Photoshop</li>
                <li>Illustrator, Inkscape</li>
                <!-- <li>Inkscape</li> -->
                <li>Cinema4D</li>
              </ul>

              <!-- <p>
                                Desweiteren habe ich bereits mit nachstehenden serverseitigen Applikationen gearbeitet.
                            </p> -->
              <h6>Serverseitige Kenntnisse</h6>
              <ul class="card-list">
                <li>PHP</li>
                <li>ASP.NET</li>
                <li>MySQL</li>
              </ul>

              <h6>Versionierungs-Systeme</h6>
              <ul class="card-list">
                <li>
                  Git (GitHub: <a href="https://github.com/Quaese">Quaese</a>)
                </li>
                <li>CVS</li>
              </ul>

              <h6>Agile Entwicklung</h6>
              <ul class="card-list last">
                <li>Scrum</li>
              </ul>

              <!-- <h6>Package Manager</h6>
                            <ul class="card-list">
                                <li>NPM (Node Package Manager)</li>
                                <li>Bower</li>
                            </ul> -->
            </div>
          </div>
          <!-- .card -->
        </div>
      </div>
      <!-- .row -->
    </div>
    <!-- .container -->

    <div class="blue-grey darken-1 white-text">
      <div class="container">
        <div class="row row-padding">
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://vuejs.org/"
                ><img
                  :src="require('@/assets/images/layout/logo-vue.svg')"
                  alt="Vue.js"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://reactjs.org/"
                ><img
                  :src="require('@/assets/images/layout/logo-react.svg')"
                  alt="React"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://svelte.dev/"
                ><img
                  :src="require('@/assets/images/layout/logo-svelte.svg')"
                  alt="Gulp"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://angular.io/"
                ><img
                  :src="require('@/assets/images/layout/logo-angular.svg')"
                  alt="Angular"
              /></a>
            </div>
          </div>

          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://github.com/"
                ><img
                  :src="require('@/assets/images/layout/logo-github.png')"
                  alt="GitHub"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://jquery.com/"
                ><img
                  :src="require('@/assets/images/layout/logo-jquery.svg')"
                  class="logo-jquery"
                  alt="jQuery"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="https://nodejs.org"
                ><img
                  :src="require('@/assets/images/layout/logo-nodejs.svg')"
                  alt="NodeJS"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="http://materializecss.com/"
                ><img
                  src="@/assets/images/layout/materialize.png"
                  alt="Materialize"
              /></a>
            </div>
          </div>

          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="http://getbootstrap.com/"
                ><img src="@/assets/images/layout/bootstrap.png" alt="Bootstrap"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="http://gulpjs.com/"
                ><img src="@/assets/images/layout/gulp.png" alt="Gulp"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="http://gruntjs.com/"
                ><img src="@/assets/images/layout/grunt.png" alt="Grunt"
              /></a>
            </div>
          </div>
          <div class="col s6 m6 l3">
            <div class="card-panel logo-card valign-wrapper white">
              <a href="http://bower.io/"
                ><img src="@/assets/images/layout/bower.png" alt="Bower"
              /></a>
            </div>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
    </div>

    <div class="container">
      <div class="row padding-top-medium">
        <h3 class="col s12">Community</h3>
      </div>
      <!-- .row -->

      <div :class="`card-panel ${css.cardLightColored}`">
        <div class="row">
          <div class="col s12 m12 l4">
            <p>
              <i class="material-icons icon-left medium">chat_bubble_outline</i>
              Seit dem 17. Februar 2004 bin ich unter dem Nick
              <strong>Quaese</strong> registrierter Nutzer des Angebotes von
              <a
                class="text"
                href="http://www.tutorials.de/"
                title="www.tutorials.de"
                >www.tutorials.de</a
              >, einer der größten deutsch- sprachigen Anlaufstellen für aktive
              und angehende Designer, Entwickler und Webworker im Netz.
            </p>
            <!-- <p class="z-depth-1"></p> -->
          </div>
          <div class="col s12 m6 l4">
            <p>
              Mit der Registrierung habe ich begonnen, anderen Usern meine
              <strong>Hilfe</strong>
              regelmässig im Forum für Webmaster anzubieten. In knapp 3700
              Beiträgen wurden bisher
              <strong>Hilfestellungen</strong> und
              <strong>Lösungen</strong> angeboten. Mein spezielles Augenmerk
              galt hierbei den Unterforen <strong>CSS</strong>,
              <strong>JavaScript</strong> und <strong>HTML</strong>.
            </p>
          </div>
          <div class="col s12 m6 l4">
            <!-- <ul>
                            <li>CSS</li>
                            <li>JavaScript</li>
                            <li>HTML</li>
                        </ul> -->
            <p>
              Mittlerweile habe ich dort aufgrund meiner fachlichen Kompetenz
              und der Kontinuität den Status des
              <strong>Moderators</strong> erreicht.
            </p>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .card-panel -->
    </div>
  </div>
</template>

<script>
export default {
  name: "compentences",

  data() {
    return {
      css: {
        cardLight: "grey lighten-5",
        cardLightColored: "blue-grey lighten-5"
      },

      pageName: "Willkommen!"
    };
  }
};
</script>

<style lang="less" scoped></style>
